module.exports = __webpack_public_path__ + "img/no-docs.68a2e27.png";